module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/incidences/incidence-list/incidence-list.component.sass
// module id = ./src/app/incidences/incidence-list/incidence-list.component.sass
// module chunks = main